































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EdithandleContent from "../outairhandlewarning/edit-outairhandleContent.vue";
import SeethhandleContent from "../outairhandlewarning/see-outairhandleContent.vue";
class PageThRealTimeDataRequest extends PageRequest {
  FilterText: string;
  cId: Number;
  AddTime: Date = new Date();
  hType:number = 2;
  ftId:Number;
  fId:Number;
  wId:Number;
}
class PageCompanyRequest {
  cId: Number;
  ftId:Number;
  fId:Number;
  wId:Number;
}
@Component({
  components: { EdithandleContent, SeethhandleContent },
})
export default class Floors extends AbpBase {
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  seeModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
  cId: Number;
  mac: string = "";
  locationName: string = "";
  minTemp: number;
  maxTemp: number;
  minHumi: number;
  maxHumi: number;
  selDateTime: Date = new Date();
  searchInt: number = 0;
  selwarehouselist = [];
  selfloorlist = [];

  get list() {
    return this.$store.state.outair_handlewarning.list;
  }
  get loading() {
    return this.$store.state.outair_handlewarning.loading;
  }
  selCompany(value: Number) {
    this.pagecompanyrequest.cId = value;
    this.getwarehouse();
    this.getfloor();
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("outair_handlewarning/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("outair_handlewarning/setPageSize", pagesize);
    this.getpage();
  }
  getsearch() {
    this.searchInt = 1;
    this.getpage();
  }
  async getpage() {
    if (this.searchInt == 1) {
      this.$store.state.thequipment.currentPage = 1;
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = 0;
      this.searchInt = 0;
    } else {
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    }
    if(this.pagerequest.AddTime.toString() == ""){
      this.pagerequest.AddTime = new Date();
    }
    //filters
    await this.$store.dispatch({
      type: "outair_handlewarning/getPaged",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  see() {
    this.seeModalShow = true;
  }
  get pageSize() {
    return this.$store.state.outair_handlewarning.pageSize;
  }
  get totalCount() {
    return this.$store.state.outair_handlewarning.totalCount;
  }
  get currentPage() {
    return this.$store.state.outair_handlewarning.currentPage;
  }
  getuserName() {
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist() {
    return this.$store.state.factory.list;
  }
  get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist() {
    return this.$store.state.smokecrib.list;
  }
  //  analyse() {
  //   this.selDateTime=this.pagerequest.AddTime;
  //   this.analyseModalShow = true;
  // }
  setmac(val) {
    this.mac = val;
  }
  setNames(paramftid, paramwid, paramfid, paramlocation) {
    let ftid = paramftid;
    let wid = paramwid;
    let fid = paramfid;
    let ftlist = this.factorylist();
    for (let entry of ftlist) {
      if (ftid == entry.id) {
        ftid = entry.fName;
        break;
      }
    }
    let wlist = this.warehouselist();
    for (let entry of wlist) {
      if (wid == entry.id) {
        wid = entry.wName;
        break;
      }
    }
    let flist = this.floorlist();
    for (let entry of flist) {
      if (fid == entry.id) {
        fid = entry.fName;
        break;
      }
    }
    this.locationName = ftid + wid + fid + paramlocation;
    if (ftid == 0) {
      this.locationName = wid + fid + paramlocation;
    }
  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist();
        for (let entry of flist) {
          if (Id == entry.id) {
            Id = entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房",
      key: "wId",
      render: (h, params) => {
        let wId = params.row.wId;
        let clist = this.warehouselist();
        //console.log(clist);
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if (wId == entry.id) {
            wId = entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let clist = this.floorlist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if (fId == entry.id) {
            fId = entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "snid",
    },
    {
      title: "位置",
      key: "locationName",
    },
    {
      title: "预警类型",
      key: "type",
      render: (h, params) => {
        let type = params.row.type;
        if (type == 1) {
          return h("span", "PM2.5");
        } else if (type == 2) {
          return h("span", "PM10");
        }else if (type == 3) {
          return h("span", "VOC挥发物");
        }else if (type == 4) {
          return h("span", "温度");
        }else if (type == 5) {
          return h("span", "湿度");
        }else if (type == 6) {
          return h("span", "风速");
        }else if (type == 7) {
          return h("span", "风向");
        }else if (type == 8) {
          return h("span", "噪音");
        }else if (type == 9) {
          return h("span", "大气压");
        }
      },
    },
    {
      title: "预警数值",
      key: "num",
    },
    {
      title: "更新时间",
      key: "addTime",
      render: (h, params) => {
        let addTime = "";

        addTime =
          this.GetDay(params.row.addTime) +
          " " +
          this.GetMinutes(params.row.addTime);
        return h("span", addTime);
      },
    },
    {
      title: "是否处理",
      key: "htype",
      width: 100,
      render: (h, params) => {
        let htype = params.row.htype;
        let returns = "待处理";
        if (htype == 1) {
          returns = "已处理";
        }
        return h("span", returns);
      },
    },
    {
      title: "处理人",
      key: "handlerOne",
    },
    {
      title: "处理时间",
      key: "hTime",
      render: (h, params) => {
        let hTime = "";

        hTime =
          this.GetDay(params.row.hTime) +
          " " +
          this.GetMinutes(params.row.hTime);
        return h("span", hTime);
      },
    },
    {
      title: "处理内容",
      key: "hContent",
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        if (params.row.htype == 0) {
          return h("div", [
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    //console.log(params.row)
                    if (params.row.handlerOne == "") {
                      params.row.handlerOne = this.$store.state.session.user
                        ? this.$store.state.session.user.name
                        : "";
                    }
                    this.$store.commit("outair_handlewarning/edit", params.row);
                    this.edit();
                  },
                },
              },
              "预警处理"
            ),
          ]);
        } else {
          return h("span", "无");
          //   return h("div", [
          //   h(
          //     "Button",
          //     {
          //       props: {
          //         type: "primary",
          //         size: "small",
          //       },
          //       style: {
          //         marginRight: "5px",
          //       },
          //       on: {
          //         click: () => {
          //           //console.log(params.row)
          //           if(params.row.handlerOne == ''){
          //             params.row.handlerOne =this.$store.state.session.user? this.$store.state.session.user.name: "";
          //           }
          //           params.row.hTime = this.GetDay(params.row.hTime)+' '+this.GetMinutes(params.row.hTime);
          //           this.$store.commit("outair_handlewarning/see", params.row);
          //           this.see();
          //         },
          //       },
          //     },
          //     "查看"
          //   ),
          // ]);
        }
      },
    },
  ];
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    this.pagerequest.ftId = value;
    if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
       this.$store.state.thequipment.currentPage=1;
       this.getpage();
  }
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
    this.pagerequest.wId = value;
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
       this.$store.state.thequipment.currentPage=1;
       this.getpage();
  }
   async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  selfloor(value:Number){
       this.$store.state.thequipment.currentPage=1;
       this.pagerequest.fId = value;
       this.getpage();
  }
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory() {
    //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getsmokecrib() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
      data: this.pagecompanyrequest,
    });
  }
  GetDay(time) {
    let date = new Date(time);
    let Str =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getHours()) +
      ":" +
      this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetBqMinutes(str) {
    if (str.toString().length == 1) {
      return "0" + str;
    }
    return str;
  }
  created() {
    //console.log(111);
    this.getuserName();
    if (this.userName !== "admin") {
      this.getfactory();
      this.getwarehouse();
      this.getfloor();
      this.getsmokecrib();

      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getpage();
  }
}
